"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const payments_1 = require("../../payments");
class InvoiceLineItem {
    constructor(date, certificateNumber, productName, premium, serviceFee, tax, total, paymentType, purchasedBy) {
        this.date = date;
        this.certificateNumber = certificateNumber;
        this.productName = productName;
        this.premium = premium;
        this.serviceFee = serviceFee;
        this.tax = tax;
        this.total = total;
        this.paymentType = paymentType;
        this.purchasedBy = purchasedBy;
    }
    static fromObj(data) {
        var _a, _b, _c;
        return new InvoiceLineItem(data.date, (_a = data.certificateNumber) !== null && _a !== void 0 ? _a : "", data.productName, data.premium, data.serviceFee, (_b = data.tax) !== null && _b !== void 0 ? _b : data.taxesAndFees, data.total, (_c = data.paymentType) !== null && _c !== void 0 ? _c : payments_1.ePaymentType.INVOICE, data.purchasedBy);
    }
}
exports.default = InvoiceLineItem;
//# sourceMappingURL=invoiceLineItem.class.js.map